import { render, staticRenderFns } from "./CardAccreditation.vue?vue&type=template&id=88f09068&"
import script from "./CardAccreditation.vue?vue&type=script&lang=js&"
export * from "./CardAccreditation.vue?vue&type=script&lang=js&"
import style0 from "./CardAccreditation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports